export interface IRecipient {
    name?: string;
    email?: string;
}

export class Recipient implements IRecipient {
    constructor(
        public name?: string,
        public email?: string
    ) {}
}
